export const MAIL_SUBJECT_BASE = '週報連';
export const CRLF = '\r\n';

export const EMAIL_TITLE_COLOR = '#2741D3';
export const EMAIL_BODY_COLOR = '#000';
export const EMAIL_FEEDBACK_COLOR = '#1B7F3A';
export const EMAIL_FONT_FAMILY =
  "'Meiryo UI','Meiryo','MS PGothic','Hiragino Kaku Gothic ProN','Hiragino Sans',sans-serif";

export const MAIL_FORMAT_PRESET_APP = 'app';
export const MAIL_FORMAT_PRESET_NO_WRAP = 'no_wrap';
export const APP_EMAIL_BODY_WRAP_CHARS = 56;

// Header labels used in .eml (Unicode escapes to avoid mojibake)
export const EMAIL_HEADER_LABEL_AUTHOR = '\u5831\u544a\u8005';
export const EMAIL_HEADER_LABEL_TEAM = '\u8077\u5236';
export const EMAIL_HEADER_LABEL_RESPONDENTS = '\u9023\u540d';
export const EMAIL_HEADER_SEPARATOR = '\uFF1A';
export const EMAIL_HEADER_BRACKET_OPEN = '\u3010';
export const EMAIL_HEADER_BRACKET_CLOSE = '\u3011';
export const EMAIL_HEADER_ANGLE_OPEN = '\uFF1C';
export const EMAIL_HEADER_ANGLE_CLOSE = '\uFF1E';
export const EMAIL_HEADER_RESPONDENTS_SEPARATOR = ':';
export const EMAIL_HEADER_RESPONDENTS_DELIM = ', ';
export const EMAIL_HEADER_PAREN_OPEN = '(';
export const EMAIL_HEADER_PAREN_CLOSE = ')';

export const CREATE_BY_NONE_PARAM = 'create_by_none';
// Start date preset values: this | last | next
export const START_DATE_PRESET_PARAM = 'start_preset';

export const SEARCH_PARAM_KEYS = [
  'wr_id',
  'start_date',
  'end_date',
  'free_word',
  'search_title_body',
  'search_tags',
  'report_types',
  'teams',
  'create_by',
  'create_by_user_ids',
  'legacy_create_by',
  'departments',
  'temporary_flg',
  CREATE_BY_NONE_PARAM,
  START_DATE_PRESET_PARAM,
] as const;

export const API_GET_WR_PUBLIC_SETTING = '/get_wr_public_setting';

/* =========================================================
 * 検索画面用 localStorage
 * ======================================================= */
export const WEEKLY_SEARCH_SCREEN_CACHE_VERSION = 3;
export const WEEKLY_SEARCH_SCREEN_CACHE_KEY_PREFIX = 'weekly-search-screen-cache';

export const WEEKLY_SEARCH_SCREEN_RESULTS_CACHE_VERSION = 3;
export const WEEKLY_SEARCH_SCREEN_RESULTS_CACHE_KEY_PREFIX =
  'weekly-search-screen-results-cache';

export const WEEKLY_SEARCH_CREATOR_OPTIONS_CACHE_VERSION = 3;
export const WEEKLY_SEARCH_CREATOR_OPTIONS_CACHE_KEY_PREFIX =
  'weekly-search-creator-options-cache';

export const WEEKLY_SEARCH_SCREEN_CACHE_KEY_LATEST =
  `${WEEKLY_SEARCH_SCREEN_CACHE_KEY_PREFIX}::latest`;

export const WEEKLY_SEARCH_SCREEN_RESULTS_CACHE_KEY_LATEST =
  `${WEEKLY_SEARCH_SCREEN_RESULTS_CACHE_KEY_PREFIX}::latest`;

export const WEEKLY_SEARCH_MAIL_FORMAT_CACHE_KEY_LATEST =
  'weekly-search-mail-format-cache::latest';

/* =========================================================
 * 週報更新通知（入力修正 → 週報連へ反映）
 * - 同一タブ: CustomEvent
 * - 別タブ: storage event
 * ======================================================= */
export const WEEKLY_REPORT_UPDATED_EVENT = 'weekly-report-updated';
export const WEEKLY_REPORT_UPDATED_AT_KEY = 'weekly-report-updated-at';
